import React, { Component } from 'react';
import './style.css';

const CONTENT_WIDTH = 980;

export default class ResponsiveEmbed extends Component {
  state = { scale: 1, height: 0 };
  container = React.createRef();
  supportsZoom = window.CSS && window.CSS.supports('zoom', '1');

  scheduleUpdate = () => {
    if (this.animationFrame) return;
    this.animationFrame = window.requestAnimationFrame(() => {
      this.animationFrame = null;
      this.updateSize();
    });
  };

  updateSize = () => {
    const container = this.container.current;
    if (!container || !container.clientWidth || !container.clientHeight) return;

    // Native pinch zoom must not resize/re-layout the embedded site. A real
    // width change (rotation, split view) still needs to update its dimensions.
    const viewport = window.visualViewport;
    if (viewport && viewport.scale > 1.01 &&
        container.clientWidth === this.lastWidth) return;

    this.lastWidth = container.clientWidth;
    const scale = Math.min(1, container.clientWidth / CONTENT_WIDTH);
    const height = Math.floor(container.clientHeight / scale);
    if (scale !== this.state.scale || height !== this.state.height) {
      this.setState({ scale, height });
    }
  };

  componentDidMount() {
    this.updateSize();
    window.addEventListener('resize', this.scheduleUpdate);
    window.addEventListener('orientationchange', this.scheduleUpdate);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.scheduleUpdate);
    }
    if (window.ResizeObserver) {
      this.resizeObserver = new window.ResizeObserver(this.scheduleUpdate);
      this.resizeObserver.observe(this.container.current);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.scheduleUpdate);
    window.removeEventListener('orientationchange', this.scheduleUpdate);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.scheduleUpdate);
    }
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
  }

  render() {
    const { src, title } = this.props;
    const { scale, height } = this.state;
    return (
      <div className="responsive-embed" ref={this.container}>
        <iframe
          src={src}
          title={title}
          style={{
            width: CONTENT_WIDTH,
            height,
            // Avoid a transformed iframe layer during iOS pinch zoom. Keep a
            // fallback only for older browsers without CSS zoom support.
            zoom: this.supportsZoom ? scale : undefined,
            transform: this.supportsZoom ? 'none' : `scale(${scale})`,
            visibility: height ? 'visible' : 'hidden'
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      </div>
    );
  }
}
